import { interval, Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { combineEpics, ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, map, mergeMap, switchMap, take } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import RequestFailed from '../../core/events/RequestFailed';
import State from 'src/application/core/State';
import OrderPageEntered from '../../products/events/OrderPageEntered';
import OrderCurrentReceived from '../events/OrderCurrentReceived';
import OrderPlaceSucceed from '../events/OrderPlaceSucceed';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';

const withDelay = (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(OrderPlaceSucceed.type),
        mergeMap(() => interval(1000).pipe(take(2))),
        mergeMap(() => getCurrentOrder(event$, state$, backend))
    );

const immediately = (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(OrderPageEntered.type),
        switchMap(() => getCurrentOrder(event$, state$, backend))
    );

export const getCurrentOrder = (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> => {
    return backend.get(`${api()}orders/current`).pipe(
        map(
            (ajaxResponse: AjaxResponse) =>
                new OrderCurrentReceived(
                    ajaxResponse.response.estimations,
                    ajaxResponse.response.order,
                    ajaxResponse.response.orderedSku,
                    ajaxResponse.response.liabilityMet,
                    ajaxResponse.response.orderedCheckout,
                    ajaxResponse.response.orderedStock,
                    ajaxResponse.response.estimated
                )
        ),
        catchError((e: AjaxError) => of(new RequestFailed(e.status)))
    );
};

export default combineEpics(immediately, withDelay);



// WEBPACK FOOTER //
// ./src/application/order/epic/orderCurrentGet.ts